import { CheckOutlined } from "@ant-design/icons";
import { Table } from "@shared/ui";
import type { ColumnsType } from "antd/es/table";

import { ROUTES } from "@app/constants";
import { IBrief } from "@shared/lib/types/brief";
import styles from "./CampaignSelectionTable.module.scss";

interface CampaignSelectionTableProps {
  dataSource: IBrief[];
  selectedCampaigns: string[];
  onToggleCampaign: (id: string) => void;
  isFetching: boolean;
  
}

export function CampaignSelectionTable({
  dataSource,
  selectedCampaigns,
  onToggleCampaign,
  isFetching,
  
}: CampaignSelectionTableProps) {
  const columns: ColumnsType<IBrief> = [
    {
      title: "",
      key: "select",
      width: 48,
      align: "center",
      render: (_, record) => (
        <div
          className={`${styles.checkbox} ${
            selectedCampaigns.includes(record._id) ? styles.checkboxChecked : ""
          }`}
        >
          {selectedCampaigns.includes(record._id) && (
            <CheckOutlined className={styles.checkIcon} />
          )}
        </div>
      ),
    },
    {
      title: "Campaign Name",
      dataIndex: "name",
      key: "name",
      render: (name: string) => (
        <span className={styles.campaignName}>{name}</span>
      ),
    },
    {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      render: (_: unknown, record: IBrief) => (
        <span className={styles.campaignBrand}>{record.brand?.name}</span>
      ),
    },
    {
      title: "",
      key: "action",
      align: "right",
      render: (_, record) => (
        <a
          href={ROUTES.BRIEF_V2.replace(":briefId", record._id)}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.viewLink}
          onClick={(e) => e.stopPropagation()}
        >
          View Details
        </a>
      ),
    },
  ];



  const columnsWithHeaderCheck: ColumnsType<IBrief> = [
    {
      ...columns[0],
      title: <></>,
    },
    ...columns.slice(1),
  ];

  return (
    <div className={styles.tableWrap}>
      <div className={styles.scrollWrap}>
        <Table<IBrief>
          loading={isFetching}
          rowKey="id"
          columns={columnsWithHeaderCheck}
          dataSource={dataSource}
          pagination={false}
          showHeader
          onRow={(record) => ({
            onClick: () => onToggleCampaign(record._id),
            className: `${styles.clickableRow} ${
              selectedCampaigns.includes(record._id) ? styles.rowSelected : ""
            }`,
          })}
          locale={{ emptyText: "No campaigns found." }}
        />
      </div>
    </div>
  );
}
